export default "__VITE_ASSET__06e8ea40__"